import { ToggleSwitch } from "@/components";
import { RightWrapper } from "../../../components";
import { useState, useCallback, useMemo, useEffect } from "react";
import { useApi, useAlert } from "@/";
import { useSelector, useDispatch } from "react-redux";
import { addCourierSettings } from "../../../app/Slices";
const CourierMgmt = () => {
  const { callApi } = useApi();
  const { alert, AlertDialog } = useAlert();
  const dispatch = useDispatch();

  const setting = useSelector((state) => state.app.appData.courier) || [];


  const [couriers, setCouriers] = useState([]);

  useEffect(() => {
    if (Array.isArray(setting) && setting.length > 0) {
      setCouriers(
        setting.map((courier) => ({
          id: courier._id || `default_id_${courier.code}`,
          name: courier.displayName || courier.name,
          icon: courier.logoUrl, // Using logoUrl from API as the icon
          isActive: courier.isActive ?? false, // Directly getting isEnabled from API
        }))
      );
    }
  }, [setting]);

  const handleToggle = useCallback(
    async (courierId) => {
      // Find the courier and its current state before updating
      const currentCourier = couriers.find((c) => c.id === courierId);
      const newIsActive = !currentCourier.isActive;

      // Prepare the payload with the intended new state
      const payload = {
        config: couriers.map((courier) => ({
          courierId: courier.id,
          isEnabled: courier.id === courierId ? newIsActive : courier.isActive,
        })),
      };

      try {
        const response = await callApi(
          "admin/courierManagement",
          "PUT",
          payload
        );

        if (!response.success) {
          throw new Error(
            response.error.message || "Failed to update courier settings."
          );
        }
        console.log("after api call");
        // Only update the UI state after successful API call

        dispatch(addCourierSettings(response.data));
        alert("Courier settings updated successfully!");
      } catch (error) {
        console.error(
          "Failed to update courier settings:",
          error.message || error
        );
        alert("Failed to update courier settings. Please try again later.");
      }
    },
    [couriers, callApi, dispatch, alert]
  );

  const courierList = useMemo(
    () =>
      couriers.map((courier) => (
        <div
          key={courier.id}
          className="flex justify-between items-center w-full bg-background_2 p-4 rounded-xl gap-2"
        >
          <img
            src={courier.icon}
            alt={courier.name}
            className="w-1/2 md:w-fit"
          />
          <ToggleSwitch
            checked={courier.isActive}
            onClick={() => handleToggle(courier.id)}
          />
        </div>
      )),
    [couriers, handleToggle]
  );

  return (
    <RightWrapper>
      <div className="flex flex-col gap-4 mt-2 px-2 relative pb-20 md:pb-4">
        <div className="flex flex-col gap-1 w-full">
          <h1 className="text-headline4 md:text-headline3 font-nunito text-secondary/95 font-semibold">
            Courier Management
          </h1>
          <p className="text-body2 font-ptsans text-secondary/60 lg:w-[50%]">
            Efficiently manage multiple courier partners by enabling or
            disabling them as needed, ensuring streamlined operations and
            flexibility in delivery options.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mt-4">
          {courierList}
        </div>
      </div>
      <AlertDialog />
    </RightWrapper>
  );
};

export default CourierMgmt;
